module.exports = __webpack_public_path__ + "static/media/blackCalendar.c8e83271.svg";